import Vue from 'vue'
import Router from 'vue-router'
import * as exam from './exam'
import * as distribution from './distribution'
import * as pin from './pintuan'
import * as integral from './integral'
import {
  getUser
} from '@/common/js/cache'

const HomePage = () => import('@/page/HomePage')
const Live = () => import('@/page/Live')
const Lession = () => import('@/page/LessionPage')
const LessionDetail = () => import('@/page/lessionDetail')
const Learn = () => import('@/page/Learn')
const LearnDetail = () => import('@/page/LearnDetail')
const LessionList = () => import('@/page/LessionList')

const my = () => import('@/page/my')
const personInfo = () => import('@/page/personInfo')
const orderList = () => import('@/page/orderList')
const collect = () => import('@/page/collect')
const study = () => import('@/page/study')
const feedback = () => import('@/page/feedback')
const message = () => import('@/page/message')
const aboutme = () => import('@/page/aboutme')
const download = () => import('@/page/download')
const login = () => import('@/page/login')
//const register = () => import('@/page/register')
const watch = () => import('@/page/watch')
const notfound = () => import('@/page/notfound')
const pay = () => import('@/page/pay')
const payorder = () => import('@/page/payorder')
const address = () => import('@/page/address')

const packagelist = () => import('@/page/packagelist')
const audition = () => import("@/page/audition")

const freevideopage = () => import("@/page/freevideopage")
const freecourse = () => import("@/page/freecourse")

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      redirect: '/HomePage'
    },
    {
      path: '/HomePage',
      name: 'HomePage',
      component: HomePage
    },
    // 课程列表页
    {
      path: '/LessionList',
      name: 'LessionList',
      component: LessionList
    },
    {
      path: '/Live',
      name: 'Live',
      component: Live
    },
    {
      path: '/Lession',
      name: 'Lession',
      component: Lession
    },
    {
      path: '/Learn',
      name: 'Learn',
      component: Learn
    },
    {
      path: '/LearnDetail',
      name: 'LearnDetail',
      component: LearnDetail
    },
    {
      path: '/LessionDetail',
      name: 'LessionDetail',
      component: LessionDetail
    },
    {
      path: '/my',
      name: 'My',
      component: my
    },
    {
      path: '/personinfo',
      name: 'personInfo',
      component: personInfo
    },
    {
      path: '/orderlist',
      name: 'orderList',
      component: orderList
    },
    {
      path: '/collect',
      name: 'collect',
      component: collect
    },
    {
      path: '/study',
      name: 'study',
      component: study
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback
    },
    {
      path: '/message',
      name: 'message',
      component: message
    },
    {
      path: '/aboutme',
      name: 'aboutme',
      component: aboutme
    },
    {
      path: '/download',
      name: 'download',
      component: download
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: register
    // },
    {
      path: '/watch/:id',
      name: 'watch',
      component: watch
    },
    {
      path: '*',
      name: 'notfound',
      component: notfound
    },
    {
      path: '/pay/:id',
      name: 'pay',
      component: pay
    },
    {
      path: '/payorder',
      name: 'payorder',
      component: payorder
    },
    {
      path: '/address',
      name: 'address',
      component: address
    },
    {
      path: '/packagelist', //package 类型
      name: 'packagelist',
      component: packagelist
    },
    // 考试一类
    {
      path: '/examCourse',
      name: 'examCourse',
      component: exam.EXAM_COURSE
    },
    {
      path: '/exam',
      name: 'exam',
      component: exam.EXAM_HOME,
    },
    {
      path: '/DayPractice',
      name: 'DayPractice',
      component: exam.DAY_PRACTICE
    },
    {
      path: '/TrueTopic',
      name: 'TrueTopic',
      component: exam.TRUE_TOPIC
    },
    {
      path: '/Assessment',
      name: 'Assessment',
      component: exam.ASSESSMENT
    },
    {
      path: '/Wrong',
      name: 'Wrong',
      component: exam.WRONG
    },
    {
      path: '/CollectTopic',
      name: 'CollectTopic',
      component: exam.COLLECT
    },
    {
      path: '/QuestionRecord',
      name: 'QuestionRecord',
      component: exam.QUESTION_RECORD
    },
    {
      path: '/AnswerSheet',
      name: 'AnswerSheet',
      component: exam.ANSWER_SHEET
    },
    {
      path: '/ExamChapter',
      name: 'ExamChapter',
      component: exam.EXAM_CHAPTER
    },
    {
      path: '/ExamStartChapter',
      name: 'ExamStartChapter',
      component: exam.EXAM_CHANPTER_START
    },
    {
      path: '/MockExamList',
      name: 'MockExamList',
      component: exam.MOCK_EXAM_LIST
    },
    {
      path: '/StartMockExam',
      name: 'StartMockExam',
      component: exam.MOCK_EXAM
    },
    {
      path: '/StartTrueExam',
      name: 'StartTrueExam',
      component: exam.START_TRUE_EXAM
    },
    {
      path: '/WrongAnlysis',
      name: 'WrongAnlysis',
      component: exam.WRONG_ANALYSIS
    },
    {
      path: '/pin',
      component: pin.PIN,
      children: [{
          path: 'pindetail',
          name: 'PIN_DETAIL',
          component: pin.PIN_DETAIL
        },
        {
          path: 'mypin',
          name: 'PIN_MY',
          component: pin.PIN_MY
        },
        {
          path: 'pinsuccess',
          name: 'PIN_SUCCESS',
          component: pin.PIN_SUCCESS
        },
        {
          path: 'pinstatus',
          name: 'PIN_STATUS',
          component: pin.PIN_STATUS
        }
      ]
    },
    {
      path: '/saleuser',
      name: 'saleuser',
      component: distribution.saleuser
    },
    {
      path: '/income',
      name: 'income',
      component: distribution.income
    },
    {
      path: '/posterlist',
      name: 'posterlist',
      component: distribution.posterlist
    },
    {
      path: '/postershare',
      name: 'postershare',
      component: distribution.postershare
    },
    {
      path:'/audition',
      name:'/audition',
      component: audition
    },
    {
      path:'/integral',
      name:'integral',
      component:integral.integral
    },
    {
      path:'/integrallist',
      name:'integrallist',
      component:integral.integrallist
    },
    {
      path:'/freevideopage',
      name:'freevideopage',
      component:freevideopage
    },
    {
      path:'/freecourse',
      name:'freecourse',
      component:freecourse
    }
  ]
})


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


let routeList = ['examCourse', 'exam', 'DayPractice', 'TrueTopic', 'Assessment', 'Wrong', 'CollectTopic', 'QuestionRecord', 'AnswerSheet', 'ExamChapter', 'ExamStartChapter', 'MockExamList', 'StartMockExam', 'StartTrueExam', 'WrongAnlysis','integral']

// 路由守卫
// 进入特定页面前判断是否已登录，未登录跳转到登录页面
router.beforeEach((to, from, next) => {
  if (routeList.indexOf(to.name) > -1) {
    if (!getUser()) {
      console.log('this.$router')
      next({
        name: 'login'
      })
    }
  }
  next()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js